import { render, staticRenderFns } from "./ManOnLaptop.vue?vue&type=template&id=160863d7&scoped=true&"
import script from "./ManOnLaptop.vue?vue&type=script&lang=js&"
export * from "./ManOnLaptop.vue?vue&type=script&lang=js&"
import style0 from "./ManOnLaptop.vue?vue&type=style&index=0&id=160863d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160863d7",
  null
  
)

export default component.exports